import { render, staticRenderFns } from "./PanelAdminComercio.vue?vue&type=template&id=4e1ded5f&"
import script from "./PanelAdminComercio.vue?vue&type=script&lang=js&"
export * from "./PanelAdminComercio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports